export default [
  { header: 'Experiments' },

  { title: 'All Experiments', route: 'v1_experiments', icon: 'none' },

  {
    title: 'Concrete',
    route: { name: 'v1_experiment_details_1', params: { id: 3 } },
    icon: 'none',
    exact: true,
  },
  {
    title: 'HVAC',
    route: { name: 'v1_experiment_details_2', params: { id: 4 } },
    icon: 'none',
    exact: true,
  },
  {
    title: 'Steel',
    route: { name: 'v1_experiment_details_3', params: { id: 7 } },
    icon: 'none',
    exact: true,
  },
]
